import styled from 'styled-components';
import { NAVBAR_HEIGHT } from 'design-system/src/components/TopNavbar/TopNavbar';
import { LogoLink } from 'design-system/src/components/Logo/LogoLink';
import { LongLogoLink } from 'design-system/src/components/Logo/LongLogoLink';

export const DividerPipe = styled.div`
  width: 1px;
  height: 24px;
  background-color: var(--grayscale-100);
  margin: 0 8px;
`;
const StyledHeader = styled.div<{ $centered?: boolean }>`
  display: flex;
  justify-content: ${({ $centered }) => ($centered ? 'center' : 'space-between')};
  align-items: center;
  height: ${NAVBAR_HEIGHT}px;
  gap: 8px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 12px 24px;
  background-color: var(--white);
  border-bottom: 1px solid var(--grayscale-100);
`;

const LeftContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export function FormTopBar({
  leftContent,
  rightContent,
  bottomContent,
  showLogo = true,
}: {
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  bottomContent?: React.ReactNode;
  showLogo?: boolean;
}) {
  if (leftContent === undefined && rightContent === undefined) {
    if (!showLogo) {
      return null;
    }
    return (
      <Container>
        <StyledHeader $centered={true}>
          <LongLogoLink />
        </StyledHeader>
        {bottomContent}
      </Container>
    );
  }

  return (
    <Container>
      <StyledHeader $centered={false}>
        <LeftContentContainer>
          {showLogo && <LogoLink />}
          {leftContent ? (
            <>
              {showLogo && <DividerPipe />}
              {leftContent}
            </>
          ) : null}
        </LeftContentContainer>
        <div>{rightContent ?? null}</div>
      </StyledHeader>
      {bottomContent}
    </Container>
  );
}
